export class DonationFormInvariantError extends Error {
  constructor(message: string) {
    super(message)
    this.name = "DonationFormInvariantError"
  }
}
export class RetryableDonationFormInvariantError extends DonationFormInvariantError {
  constructor() {
    super("Something unexpected happened. Please refresh and try again.")
    this.name = "RetryableDonationFormInvariantError"
  }
}
